// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from '/home/runner/work/app/app/node_modules/dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelAccounting0 from '/home/runner/work/app/app/src/models/accounting.ts';
import ModelContact1 from '/home/runner/work/app/app/src/models/contact.ts';
import ModelLayout2 from '/home/runner/work/app/app/src/models/layout.ts';
import ModelLead3 from '/home/runner/work/app/app/src/models/lead.ts';
import ModelMember4 from '/home/runner/work/app/app/src/models/member.ts';
import ModelUser5 from '/home/runner/work/app/app/src/models/user.ts';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: 'accounting', ...ModelAccounting0 });
app.model({ namespace: 'contact', ...ModelContact1 });
app.model({ namespace: 'layout', ...ModelLayout2 });
app.model({ namespace: 'lead', ...ModelLead3 });
app.model({ namespace: 'member', ...ModelMember4 });
app.model({ namespace: 'user', ...ModelUser5 });
  return app;
}

export function getApp() {
  return app;
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (typeof window !== 'undefined') {
      _onCreate();
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    const app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
